<template>
  <!--消息处理弹窗-->
  <div class="handle-req-dialog">
    <el-dialog
      v-model="isShowTable"
      title="消息处理"
      width="940px"
      custom-class="handleReq"
      @close="handleClose"
    >
      <el-row
        v-for="{id, formatTime,type, userName, permission, typeOfReq, idName, ambulanceNewStatu, statu } in noteCheckList"
        :key="id"
      >
        <el-col :span="6">
          {{ formatTime }}
        </el-col>
        <el-col v-if="type !== 'ambulanceNewStatu'" :span="12">
          {{ userName }} 申请 {{ permission }} {{ typeOfReq }}
        </el-col>
        <el-col v-else :span="12">
          {{ idName }} 已完成：{{
            getAmbulanceStageStatus[ambulanceNewStatu]
          }}
        </el-col>
        <el-col :span="6">
          <!-- 如果是管理员登录，则会有权限选择 -->
          <div v-if="isAdmin">
            <el-row v-show="statu === '0'">
              <el-button
                class="handle agree"
                @click="agreeRequest(id, statu)"
              >同意
              </el-button>
              <el-button
                class="handle refuse"
                @click="refuseRequest(id,statu)"
              >拒绝
              </el-button>
            </el-row>
            <el-row v-show="statu !== '0'">
              <el-button
                v-show="statu === '1'"
                class="handled agree"
              >已同意
              </el-button>
              <el-button
                v-show="statu === '2'"
                class="handled refuse"
              >已拒绝
              </el-button>
            </el-row>
          </div>
          <!-- 如果是护士或者医生登录 -->
          <!-- 只能看到三种情况  -->
          <!-- 申请待通过 申请已通过 申请未通过 -->
          <div v-else>
            <el-row v-if="statu === '0'">
              <el-button
                type="text"
                class="handled agree pending"
              >申请待通过
              </el-button>
            </el-row>
            <el-row v-else>
              <el-button
                v-show="statu === '1'"
                type="text"
                class="handled agree agreed"
              >申请已通过
              </el-button>
              <el-button
                v-show="statu === '2'"
                type="text"
                class="handled refuse refused"
              >申请未通过
              </el-button>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="hasNext">
        <el-col :span="24" style="text-align: center" @click="loadMore">加载更多</el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getPermissionList, handlePermission } from "@/api/permission";
import { mapState } from "vuex";
import { showWindowMessage } from "@utils/notification";
import { getAmbulanceStageStatus, userIds } from "@utils/basic";

export default {
  name: "HandleMessage",
  props: {
    newTable: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },

  emits: ["closeDialog", "getNewList"],
  data() {
    return {
      page: 1,
      isShowTable: false,
      noteCheckList: [],
      getAmbulanceStageStatus: getAmbulanceStageStatus,
      isAdmin: false, // 登录身份是否为管理员
      userIds: userIds,
      hasNext: 0,
    };
  },
  computed: {
    ...mapState({
      userInfo: "userInfo",
      hospitalName: "hospitalName",
      ambulanceLists: "ambulanceLists"
    }),
  },
  watch: {
    newTable: {
      handler(val) {
        this.isShowTable = val;
      },
      immediate: true
    }
  },
  mounted() {
    this.isAdmin = this.userInfo.loginUserId === 1;
    this.showTable();
  },

  methods: {
    handleClose() {
      this.$emit("closeDialog");
    },
    // 翻页加载更多
    loadMore() {
      this.page = this.page + 1;
      this.showTable(this.page);
    },
    /**
     * 点击消息图标, 弹窗显示最新消息框
     * */
    async showTable(page = 1) {
      try {
        const { code, data, next, msg } = await getPermissionList(page);
        if (code !== 200) {
          showWindowMessage(3, msg, this);
        }
        this.hasNext = next;
        data.forEach(ele => {
          ele["hospitalName"] = this.hospitalName;
          ele["role"] = this.userIds[ele.userId];
          /**
           * 应该是有一下几种几款
           * 1. checkLive 申请直播权限
           * 2. checkData 申请历史记录的监控权限
           * 3. 急救车状态表 包括 出车时刻, 到达医院等
           * */
          if (ele.type === "checkData") {
            ele["permission"] = "事例" + ele.medicalhistoryId;
            ele["typeOfReq"] = "的监控视频";
          } else if (ele.type === "checkLive") {
            const car = this.ambulanceLists.find(car => {
              return car.id === ele.ambulanceId;
            });
            if (!car) return;
            ele["permission"] = car.name + "(" + car.idName + ")";
            ele["typeOfReq"] = "的监控查看权限";
          }
        });
        this.noteCheckList = this.noteCheckList.concat(data);
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    /*
    * 同意权限申请
    * */
    async agreeRequest(id) {
      try {
        const { code, msg } = await handlePermission({ type: "agree", checkId: id });
        if (code !== 200) {
          showWindowMessage(3, msg, this);
          return;
        }
        const item = this.noteCheckList.find(item => {
          return item.id === id;
        });
        item.statu = "1";
        // await this.showTable();
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    /*
    * 拒绝权限申请
    * */
    async refuseRequest(id) {
      try {
        const { code, msg } = await handlePermission({ type: "refuse", checkId: id });
        if (code !== 200) {
          showWindowMessage(3, msg, this);
          return;
        }
        const item = this.noteCheckList.find(item => {
          return item.id === id;
        });
        item.statu = "2";
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
  }
};
</script>

<style scoped lang="scss">
/* 重写后的消息处理列表 */
.handle-req-dialog::v-deep {
  .handleReq {
    width: 786px;
    height: 500px;
    background: #FBFBFB;
    box-shadow: 0 0 6px 0 rgba(69, 69, 69, 0.4);
    border-radius: 10px;
  }

  .el-dialog__header {
    padding: 0;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #CCCCCC;

    .el-dialog__title {
      font-size: 18px;
      font-weight: bold;
      color: #1783CE;
      margin-left: 24px;
    }
  }

  .el-dialog__body {
    padding: 0;
    overflow: auto;
    height: 448px;

    .el-row {
      border-bottom: 1px solid #CCCCCC;
      color: #333333;
      padding-left: 26px;
      height: 40px;
      line-height: 40px;
      align-items: center;
    }
  }
}

.el-button {
  width: 50px;
  height: 24px;
  padding: 0;
  min-height: 24px;
  border-radius: 6px;
  color: #FBFBFB;
}

.handle.agree {
  background: #75B8E6;
}

.handle.refuse {
  background: #999999;
  margin-left: 24px;
}

.handled.refuse,
.handled.agree {
  //margin-left: 0;
  width: 124px;
  text-align: center;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  font-size: 14px;
  color: #CCCCCC;
  margin-left: 0;
}

// 下面三条为医生护士端看到的管理员回复情况 同意,待同意,拒绝
.handled.pending {
  background: transparent;
  color: #999999;
  border: none;
}

.handled.agreed {
  background: transparent;
  color: #0c618b;
  border: none;
}

.handled.refused {
  background: transparent;
  color: red;
  border: none;
}
</style>
